export default "/Frontend/dist/event-background3.519470db280a7be0da996675f2265fdf.svg";